import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

import { blockingColors } from '../tokens';

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

type SkeletonProps = {
  $width?: string;
  $height: string;
  $radius: string;
};

export const SkeletonRoot = styled('span', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<SkeletonProps>`
  display: block;
  width: ${({ $width }) => $width ?? '100%'};
  height: ${({ $height }) => $height};
  border-radius: ${({ $radius }) => $radius};
  background: linear-gradient(
    90deg,
    ${blockingColors.surface} 25%,
    #e9e9e9 37%,
    ${blockingColors.surface} 63%
  );
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;

  /* Respeita quem pediu menos movimento no sistema. */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SkeletonStack = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const SkeletonRow = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
`;
